'use strict';
import angular from 'angular';

angular.module('currentUser.services').factory('Partner', ['Role', function(Role) {
    return Role.newFrozenInstance(
        'ListOrders',
        'ViewOrder',
        'ListOrderComments',
        'CreateOrderComment',
        'ListLineItemComments',
        'CreateLineItemComment',
        'ViewLineItem',
        'ViewFlight',
    )
}])